export const MAIN = "main";
export const SCHEDULE = "schedule";
export const SUBSCRIPTION = "subscription";
export const BLOG = "blog";
export const ANNOUNCE = "announce";
export const SHOP = "shop";
